<div class="d-flex mx-0 flex-column flex-md-row justify-contet-between p-white border-bottom secondaryMenu px-4 py-3">
    <div class="d-flex flex-column col">
        <h3 class="mt-0 mb-1">My Job Requests</h3>
        <p-breadcrumb [model]="items"></p-breadcrumb>
    </div>
    <div class="d-flex justify-content-start justify-content-md-end col mt-2 mt-md-0">
        <button pButton type="button" icon="pi pi-plus" label="Add Job Request" iconPos="left" routerLink="/createJobRequest"></button>
    </div>
</div>

<div class="p-white shadow m-3">
    <p-table [value]="products" [autoLayout]="true" responsiveLayout="scroll" styleClass="p-datatable-striped">
        <ng-template pTemplate="caption">
            <div class="d-flex flex-row">
                <span class="p-input-icon-left p-ml-auto me-3">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text"  placeholder="Search keyword" />
                </span>
                <div style="position: relative;">
                    <input type="text" pInputText  placeholder="Select Date" (click)="clickEvent()">  
                    <div style="height:24px; width:24px; position: absolute; top:6px; right: 12px;" class="d-flex align-items-center justify-content-center">
                        <i class="pi pi-calendar"></i>
                    </div>
                    <div class="flex-row border shadow p-3" [ngClass]="status ? 'activated' : 'inactived'" style="position: absolute; z-index: 999; background-color: #fff; width: 800px;">
                        <div class="calanderSelector me-3">
                            <ul>
                                <li class="active">
                                    <a>Today</a>
                                </li>
                                <li>
                                    <a>Yesterday</a>
                                </li>
                                <li>
                                    <a>Last 7 Days</a>
                                </li>
                                <li>
                                    <a>Last 30 Days</a>
                                </li>
                                <li>
                                    <a>This Month</a>
                                </li>
                                <li>
                                    <a>Last Month</a>
                                </li>
                                <li>
                                    <a>Last 3 Months</a>
                                </li>
                                <li>
                                    <a>Custom Range</a>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <p-calendar  [inline]="true" [numberOfMonths]="2"></p-calendar>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
              <th  pSortableColumn="code">Job ID<p-sortIcon field="code"></p-sortIcon></th>
            <!-- <th  pSortableColumn="model">Vehicle model<p-sortIcon field="code"></p-sortIcon></th>
            <th  pSortableColumn="driver">Driver Name<p-sortIcon field="code"></p-sortIcon></th> -->
            <th>Operation <p-columnFilter type="text" field="CreatedOn" display="menu"></p-columnFilter></th>
            <th>Created On <p-columnFilter type="date" field="CreatedOn" display="menu"></p-columnFilter></th>
            <th>Created By<p-columnFilter type="text" field="CreatedBy" display="menu"></p-columnFilter> </th>
            <th>Amount (Rs) <p-columnFilter type="text" field="CreatedOn" display="menu"></p-columnFilter></th>
            <th>Status <p-columnFilter type="text" field="CreatedOn" display="menu"></p-columnFilter></th>
            <th>Progress <p-columnFilter type="text" field="CreatedOn" display="menu"></p-columnFilter></th>
            <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-product>
            <tr>
                <td><a routerLink="/jobRequestDetails">IN0000000123</a></td>
                <td>Vehicle - Running Charges</td>
                <td>Madhushani Dhanushika</td>
                <td>2021 August 12</td>
                <td>6,500</td>
                 <td>
                <p-tag styleClass="me-2 mb-1" value="Pending"></p-tag>
                <p-tag styleClass="me-2 mb-1" severity="success" value="Approved"></p-tag>
                <p-tag styleClass="me-2 mb-1" severity="info" value="Draft"></p-tag>
                <p-tag severity="danger" value="Rejected"></p-tag>
            </td>
            <td>
                <div class="d-flex flex-column justify-content-end ">
                    <div class="d-flex justify-content-end mb-1">
                        <small>10/10 Steps</small>
                    </div>
                       <div class="prog-bar-full"><p-progressBar [value]="100"></p-progressBar></div>    
                </div>
            </td> 
                <td>
                    <!-- <button pButton pRipple type="button" icon="pi pi-check" class="p-button-text"></button> -->
                    <button pButton pRipple type="button" icon="pi pi-paperclip" class="p-button-primary p-button-text" (click)="showBasicDialog()"></button>
                    <!-- <button pButton pRipple type="button" icon="pi pi-trash" class="p-button-danger p-button-text"></button> -->
                </td>
            </tr>
        </ng-template>
    </p-table>
    <div class="d-flex justify-content-end">
           
        <p-paginator [rows]="10" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="[10,20,30]"></p-paginator>
    </div>
</div>

<p-dialog header="Preview Attachments" [(visible)]="displayBasic" [style]="{width: '50vw'}" [baseZIndex]="10000">
    <div class="d-flex flex-column mb-3">
        <div class="d-flex flex-column bg-light px-3 py-2 border border-bottom-0">
            <div class="d-flex flex-row justify-content-between align-items-center">
                <p>House-rent.png</p>
                <button pButton type="button" icon="pi pi-download" label="Download" iconPos="left"></button>
            </div>
        </div>
        <div class="border border-top-0 px-3 py-2">
            <img src="/assets/img/bill.png"/>
        </div>
    </div>
</p-dialog>